/**
 * /app/trusts/$id/resolutions/$rid/sign — Resolution signing flow, trust-scoped.
 * Moved from /app/resolutions/$id/sign. Param renamed $id → $rid to avoid clash with trust $id.
 */

import { createFileRoute } from '@tanstack/react-router';
import { ResolutionSign } from '../../../../../../components/screens/resolution-sign';

export const Route = createFileRoute('/app/trusts/$id/resolutions/$rid/sign')({
  component: ResolutionSign,
});
